const Title = ({ children, className = '' }) => {
  return <div className={`text-2xl text-primary-700 font-bold ${className}`}>{children}</div>;
};

export default Title;
